var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAteCases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    style: {
      fill: "black !important"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3048_27197",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3048_27197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 10.5H7.5V9C7.5 8.7875 7.57188 8.60938 7.71563 8.46563C7.85938 8.32188 8.0375 8.25 8.25 8.25H9.75V9.75L12 7.5L9.75 5.25V6.75H8.25C7.625 6.75 7.09375 6.96875 6.65625 7.40625C6.21875 7.84375 6 8.375 6 9V10.5ZM3 13.5C2.5875 13.5 2.23438 13.3531 1.94062 13.0594C1.64687 12.7656 1.5 12.4125 1.5 12V3.75C1.5 3.3375 1.64687 2.98438 1.94062 2.69063C2.23438 2.39688 2.5875 2.25 3 2.25H15C15.4125 2.25 15.7656 2.39688 16.0594 2.69063C16.3531 2.98438 16.5 3.3375 16.5 3.75V12C16.5 12.4125 16.3531 12.7656 16.0594 13.0594C15.7656 13.3531 15.4125 13.5 15 13.5H3ZM3 12H15V3.75H3V12ZM0.75 15.75V14.25H17.25V15.75H0.75Z",
    fill: "#171A1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAteCases);
export default __webpack_public_path__ + "static/media/ate_cases.facd0d0549b21e1eec6898fe326d41ac.svg";
export { ForwardRef as ReactComponent };